<section>
    <div class="page-title">
        <h2>{{ header }}</h2>
    </div>
    <div class="progress-block">
        <h2 class="progress-header">{{ planData.header }}</h2>
        <div class="logo-block">
            <xm-media-image aria-hidden="true" size="auto" [imageOptions]="failureIcon"></xm-media-image>
        </div>
        <p class="description">{{ planData.description }}</p>
        <button class="xm-btn-primary-light" (click)="goBack()">{{ planData.goBackCtaLabel }}</button>
    </div>
</section>
